import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
// import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';

import fontAwesome from "font-awesome/scss/font-awesome.scss";
// import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
// import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';


function getRandom(min, max) {
  var random = Math.floor(Math.random() * (max + 1 - min)) + min;

  return random;
}

class ScrollReveal {
  constructor(options) {
    this.options = options;
  }

  reveal(el, options, duration) {
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire(el, function () {
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options, args);
      anime(args);
    }, {
      offset: window.innerHeight
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
    this.init();
  }

  init() {

    $(() => {
      this.menuSlide();
      this.owlCarousel();
      this.modaal();
      this.slickSlider();
      this.reveal();
    })

  }

  reveal() {
    if($(window).width() < 768){
      return false;
    }
    window.sr = new ScrollReveal({duration: 600, mobile: true});
    var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
    var baseDistance = '8';
    let humanSelector = "#mv-human01,#mv-human02,#mv-human03,#mv-human04,#mv-human05,#mv-human06";
    let bg = "#bg,#bg *";
    let item = "#mv-item01,#mv-item02,#mv-item03,#mv-item04,#mv-item05,#mv-item06,#mv-item07,#mv-item08";
    let options = "#img-mainvisual-options-01,#img-mainvisual-options-02,#img-mainvisual-options-03,#img-mainvisual-options-04,#img-mainvisual-options-05";

    let mvTitleText = ".c-main-visual__title,.c-main-visual__text,.c-main-visual__nav";

    $("#mv *").css("opacity", 0);
    $(mvTitleText).css("opacity", 0);
    // $(".l-header").css("opacity", 0);

    $("#mv").imagesLoaded(() => {
      let tl = anime.timeline({
        easing: baseEasing,
        duration: 750
      });
      tl.add({
        targets: bg,
        opacity: [0.0, 1.0],
        y: [0, 0],
        // translateX: [0, 100],
        duration: 600,
        delay: 500
      })
      tl.add({
        targets: item,
        opacity: [0.0, 1.0],
        y: [-400, 0],
        // translateX: [0, 100],
        duration: 400,
        easing: "easeOutQuad",
        delay: anime.stagger(50)
      })

      tl.add({
        targets: options,
        opacity: [0.0, 1.0],
        y: [-200, 0],
        // translateX: [0, 100],
        duration: 400,
        easing: "easeOutBounce",
        delay: anime.stagger(100),
      }, '-=450')
      tl.add({
        targets: options,
        duration: 0,
        // easing: "easeOutBounce",
        delay: 0,
        complete: function () {
          var $options = $(options)
          for (let i = 0; i < $options.length; i++) {
            let key = $options[i];
            let rand = getRandom(100, 400);
            setTimeout(()=>{
              anime({
                targets: key,
                opacity: [1, 1],
                y: [0, 15],
                direction: 'alternate',
                easing: "easeInQuad",
                loop: true,
                duration: 300,
                delay: 0,
              })
            },rand)

          }
        }
      }, '-=220')

      tl.add({
        targets: humanSelector,
        opacity: [0.0, 1.0],
        y: [-300, 0],
        // translateX: [0, 100],
        duration: 500,
        easing: "easeOutBounce",
        delay: anime.stagger(100),
      }, '-=400')
      tl.add({
        targets: mvTitleText,
        opacity: [0.0, 1.0],
        translateX: [-20, 0],
        // translateX: [0, 100],
        duration: 800,
        easing: "easeOutQuad",
        delay: anime.stagger(100),
      }, '-=100')
      // tl.add({
      //   targets: ".l-header",
      //   opacity: [0.0, 1.0],
      //   translateY: [-20, 0],
      //   // translateX: [0, 100],
      //   duration: 400,
      //   easing: "easeOutQuad",
      //   delay: anime.stagger(100),
      // }, '-=200')
      tl.play()
    });
  }

  /**
   * フッターメニューSPスライド
   * @returns {boolean}
   */
  menuSlide() {
    var win = $(window).innerWidth();
    if (win > 750) {
      return false;
    }
    $('.l-footer__block').on('click', function () {
      $(this).children(".l-footer__menutitle").toggleClass('is-open');
      $(this).children(".l-footer__menulist.is-sub").slideToggle();
    })
  }

  /**
   * OwlCarousel
   * @returns {boolean}
   */
  owlCarousel() {
    var owls = $('.owl-carousel');
    if (owls.length === 0) {
      return false
    }
    //->スライダー
    owls.imagesLoaded(function () {
      $('.c-main-visual__slider').owlCarousel({
        items: 1,
        margin: 0,
        dots: true,
        loop: true,
        nav: false,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: true,
        navText: ['<img src="/wp-content/themes/tatsue-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/tatsue-html/dist/assets/images/icon-slider-next.svg" />'],
      });
    });
    //->カード_カルーセル
    owls.imagesLoaded(function () {
      $('.js-card-slider').owlCarousel({
        margin: 0,
        dots: false,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: true,
        navText: ['<img src="/wp-content/themes/tatsue-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/tatsue-html/dist/assets/images/icon-slider-next.svg" />'],
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
          },
          // breakpoint from 750 up
          750: {
            items: 3,
          }
        }
      });
    });
  }

  slickSlider() {
    var slider = '.js-slider';
    var thumbItem = '.js-thumb-item';
    var sliderMain = "";
    var thumb = '.js-thumb';
    $('.js-slider-main').each(function (i, elm) {
      var $slider_area = $(elm).parent();
      var $main_slide = $slider_area.find(".js-slider-main");
      var $thumb_slide = $slider_area.find(".js-thumb");


      // データ属性の数字を割り振る
      $thumb_slide.find('.js-thumb-item').each(function () {
        var index = $thumb_slide.find('.js-thumb-item').index(this);
        $(this).attr("data-index", index);
      });

      // 初期化
      $main_slide.on('init', function (slick) {
        $thumb_slide.find(".js-thumb-item:first-child").addClass('thumb-current');
      });

      // サムネイルをクリックした時スライダー切り替え
      $thumb_slide.find(".js-thumb-item").on('click', function () {
        var index = $(this).attr("data-index");
        $main_slide.slick("slickGoTo", index, false);
      });

      // サムネイル画像のカレントを切り替え
      $main_slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $thumb_slide.find(".js-thumb-item").removeClass("thumb-current");
        console.log(currentSlide);
        $thumb_slide.find('.js-thumb-item[data-index="' + nextSlide + '"]').addClass("thumb-current");
      });

      // オプション
      $main_slide.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        accessibility: false,
        dots: false,
        arrows: false,
        fade: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {}
          },
        ]
      });
    });
  }

  domEach(items, callback) {
    if (typeof items === "string") {
      var items = $(items);
    }
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      // callback = callback.bind(item)
      callback(i, item);
    }
  }

  // - スクロールリーバル
  // function reveal() {
  //  function domEach(items, callback) {
  //    if (typeof items === "string") {
  //      var items = $(items);
  //    }
  //    for (var i = 0; i < items.length; i++) {
  //      var item = items[i];
  //      // callback = callback.bind(item)
  //      callback(i, item);
  //    }
  //  }
  //    window.sr = new ScrollReveal({duration: 600, mobile: true});
  //    var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
  //    var baseDistance = '8';

  // sr.reveal("", {
  //   duration: 1400,
  //   opacity: 1,
  //   //translateY: -baseDistance,
  //   delay: 900,
  //   viewFactor: .3
  // }, 100);
  //
  // sr.reveal("",{
  //   scale: [0.9, 1],
  //   opacity: 1,
  //   duration: 600,
  //   delay: anime.stagger(100),
  //   translateX: [-baseDistance,0],
  //   easing: baseEasing
  // });
  //   domEach(".c-hero-block-about__title span,.c-hero-block-lg__title-sub span,.c-box-step__item-box", function(key, item){
  //
  //     sr.reveal(item,{
  //       scale: {
  //         value: [0.9,1],
  //         // easing: "linear"
  //       },
  //       opacity: 1,
  //       duration: 100,
  //       delay: 100*key,
  //       translateY: [-baseDistance,0],
  //       easing: baseEasing,
  //     } );
  //   });
  //  domEach(".c-box-product__item-label span", function(key, item){
  //
  //    sr.reveal(item,{
  //      scale: {
  //        value: [0.9,1],
  //        // easing: "linear"
  //      },
  //      opacity: 1,
  //      duration: 100,
  //      delay: 100*key,
  //      translateY: [-baseDistance,0],
  //      easing: baseEasing,
  //    } );
  //  });
  // }

  /**
   *
   */
  modaal() {
    // ====================
    // <HTML>
    // <a href="path/to/image.jpg" class="js-modal-image" data-modaal-desc="My Description">Show</a>
    // or
    // <button data-modaal-content-source="path/to/image.jpg" class="js-modal-image">Show</button>
    // ====================

    $('.js-modal-image').modaal({
      type: 'image'
    });
    $('.js-modal-video').modaal({
      type: 'iframe',
      responsive: {
        // breakpoint from 0 up
        0: {
          height: 200,
          width: 375,
        },
        // breakpoint from 750 up
        750: {
          height: 400,
          width: 800,
        }
      }
    });
  }
}

window.GApp = new App();
